// extracted by mini-css-extract-plugin
module.exports = {"link":"NavigationItem_link__1rTWX","slide-in":"NavigationItem_slide-in__2xS6m"};